import lodashCompact from 'lodash/fp/compact';

import {
  JOB_TYPE_SUNLOCK_INSTALL,
  JOB_TYPE_SUNLOCK_TAKEDOWN,
  JOB_TYPE_YARD_SIGN_SETUP,
  JOB_TYPE_YARD_SIGN_TAKEDOWN,
  JOB_TYPE_SUPRA_LOCK_INSTALL,
  JOB_TYPE_SUPRA_LOCK_TAKEDOWN,
  JOB_TYPE_COMBO_LOCK_INSTALL,
  JOB_TYPE_COMBO_LOCK_TAKEDOWN,
  JOB_TYPE_CODEBOX_INSTALL,
  JOB_TYPE_CODEBOX_TAKEDOWN,
  JOB_TYPE_FIX,
  JOB_TYPE_SPECIAL_REQUEST,
  JOB_TYPE_PROPERTY_CHECK,
  JOB_TYPE_MEDIA_CURBSHOT,
  JOB_TYPE_REPLACE_SUNLOCK_BATTERY,
  JOB_TYPE_CHECK_DOOR_LOCK,
  JOB_TYPE_SUNLOCK_TAKEDOWN_AND_SWAP,
} from 'common/jobConstants';

import {
  PARTNER_ID_HOMERIVER,
} from 'common/partnerConstants';

export default function getJobChecklist({ job, listing }) {
  let jobChecklist;
  switch (job.jobTypeId) {
    case JOB_TYPE_SUNLOCK_INSTALL:
      jobChecklist = [
        {
          value: 'issuesInstallingSunlock',
          label: 'Were there any issues installing the Sunlock?',
        },
        {
          value: 'strikePlateRemoved',
          label: 'Strike plate removed from door frame',
        },
        {
          value: 'homeNoIssues',
          label: 'Walked through the home and saw no issues',
        },
        {
          value: 'masterCodeTested',
          label: 'Master code set and tested?',
        },
        {
          value: 'guestCodeTested',
          label: 'Guest code set and tested?',
        },
        {
          value: 'sunlockLocks',
          label: 'Sunlock locks within 60 sec',
        },
        {
          value: 'sunlockNoLongBeep',
          label: 'No long beep after Sunlock locks',
        },
        {
          value: 'sunlockNotEngage',
          label: 'Sunlock does not engage again after 60 seconds',
        },
        {
          value: 'deadboltTapeOver',
          label: 'Extra deadbolt put tape over it and leave unlocked',
        },
        {
          value: 'yellowTape',
          label: 'Yellow tape covering all inner locks',
        },
        {
          value: 'doorLockInBag',
          label: 'Original door lock in bag in kitchen cabinet in sunlock case',
        },
        {
          value: 'razPiPlugged',
          label: 'Raz pi plugged in and cellular data stick plugged in',
        },
        {
          value: 'noRedLightStick',
          label: 'No red light on cellular data stick',
        },
        {
          value: 'placardsOnDoor',
          label: 'Placards on door',
        },
        {
          value: 'urlPlacard',
          label: 'URL placard written on large url placard',
        },
        {
          value: 'sunlockKeyInSupra',
          label: 'One Sunlock key in supra (if any)',
        },
        {
          value: 'sticketLockDoor',
          label: 'Installed lock door stickers',
        },
        {
          value: 'sunlockKeyInComboLockbox',
          label: 'One Sunlock key in combo lockbox with all original door lock keys',
        },
      ];
      break;

    case JOB_TYPE_SUNLOCK_TAKEDOWN:
      jobChecklist = [
        {
          value: 'uninstallSunlock',
          label: 'Uninstall the Sunlock',
        },
        {
          value: 'getOriginalDoorLock',
          label: 'Remove the original door lock from the kitchen cabinet in the Sunlock case.',
        },
        {
          value: 'installOriginalDoorLock',
          label: 'Install the original door lock',
        },
        {
          value: 'removeTape',
          label: 'Remove any tape from the extra deadbolt',
        },
        {
          value: 'unplugRazPi',
          label: 'Unplug the Raz pi and cellular data stick.',
        },
        {
          value: 'removePlacecards',
          label: 'Remove the placards and URL placard from the door.',
        },
        {
          value: 'removeStickers',
          label: 'Remove lock door stickers.',
        },
        {
          value: 'removeComboLockbox',
          label: 'Remove combo lockbox and all keys',
        },
      ];
      break;

    case JOB_TYPE_YARD_SIGN_SETUP:
      jobChecklist = lodashCompact([
        {
          value: 'easytoPierceGround',
          label: 'Find an area with easy-to-pierce ground',
        },
        {
          value: 'signFacingRoad',
          label: 'Ensure the sign is facing the road clearly',
        },
        {
          value: 'pressFrame',
          label: 'Press down one side of the frame at a time',
        },
        {
          value: 'malletIfRequired',
          label: 'If the ground is too hard, use a mallet to tap down the top of the frame to get it lower in the ground', // eslint-disable-line max-len
        },
        {
          value: 'signIsStable',
          label: 'Ensure the sign is stable and won\'t fall over before leaving',
        },
        {
          value: 'takePhotos',
          label: 'Take completion photo and upload',
        },
        listing.partnerId !== PARTNER_ID_HOMERIVER && {
          value: 'writeUrlCodeOnPlacard',
          label: 'Write the URL code for the installed sign on the placard on the front door.',
        },
      ]);
      break;

    case JOB_TYPE_YARD_SIGN_TAKEDOWN:
      jobChecklist = [
        {
          value: 'removeAttachments',
          label: 'Remove any attachments from the sign, such as flyers or rider signs',
        },
        {
          value: 'pullSign',
          label: 'Gently pull the sign out of the ground, making sure not to damage the sign or frame',
        },
        {
          value: 'malletIfRequired',
          label: 'If necessary, use a mallet to tap down the top of the frame to get it out of the ground',
        },
        {
          value: 'checkSign',
          label: 'Check the sign and frame for any damage',
        },
        {
          value: 'takePhotos',
          label: 'Take a photo of the removed sign and upload',
        },
      ];
      break;

    case JOB_TYPE_SUPRA_LOCK_INSTALL:
      jobChecklist = [
        {
          value: 'originalKeyStored',
          label: 'Original key places into combo lockbox',
        },
        {
          value: 'troubleshooting',
          label: 'If no Combo found, I phoned Sunroom (512) 957-0512',
        },
        {
          value: 'LockboxShackled',
          label: 'Lockbox shackled',
        },
        {
          value: 'takePhotos',
          label: 'Take completion photo and upload photo',
        },
      ];
      break;

    case JOB_TYPE_SUPRA_LOCK_TAKEDOWN:
      jobChecklist = [
        {
          value: 'removeShackles',
          label: 'Remove the shackles from the lockbox.',
        },
        {
          value: 'retriveOriginalKey',
          label: 'Open the lockbox and retrieve the original key.',
        },
        {
          value: 'closeLockbox',
          label: 'Close the lockbox.',
        },
        {
          value: 'takePhotos',
          label: 'Take a completion photo and upload',
        },
      ];
      break;

    case JOB_TYPE_COMBO_LOCK_INSTALL:
      jobChecklist = [
        {
          value: 'accesibleLocation',
          label: 'Choose a secure and easily accessible location for the lockbox.',
        },
        {
          value: 'setCombination',
          label: 'Open the lockbox and set the combination',
        },
        {
          value: 'secureLockbox',
          label: 'Secure the lockbox to the chosen location',
        },
        {
          value: 'testLockbox',
          label: 'Test the lockbox to ensure it is securely attached and the combination is working correctly.', // eslint-disable-line max-len
        },
        {
          value: 'placeKeys',
          label: 'Place the keys to the property inside the lockbox',
        },
        {
          value: 'takePhotos',
          label: 'Take completion photo and upload photo',
        },
      ];
      break;

    case JOB_TYPE_COMBO_LOCK_TAKEDOWN:
      jobChecklist = [
        {
          value: 'removePropertyKeys',
          label: 'Open the lockbox and remove the keys to the property.',
        },
        {
          value: 'removeLockbox',
          label: 'Remove the lockbox from the secure location.',
        },
        {
          value: 'resetCombination',
          label: 'Reset the combination on the lockbox to its default setting.',
        },
        {
          value: 'lockboxLocked',
          label: 'Check to ensure the lockbox is securely closed and locked.',
        },
        {
          value: 'takePhotos',
          label: 'Take a photo of the removed lockbox and upload it.',
        },
      ];
      break;

    case JOB_TYPE_CODEBOX_INSTALL:
      jobChecklist = [
        {
          value: 'codeboxSpare9VBattery',
          label: 'Make sure to have a spare 9V battery in hand.',
        },
        {
          value: 'moveKeyToCodebox',
          label: 'Move one key from combo lockbox to the CodeBox.',
        },
        {
          value: 'codeboxTestKeys',
          label: (
            'Test all combo lockbox keys and write the number of working keys versus non-working ' +
            'keys in the driver notes below like "X working keys out of X non-working keys in combo lockbox"'
          ),
        },
        {
          value: 'codeboxAttachString',
          label: 'Attach key to the string in the Codebox.',
        },
        {
          value: 'codeboxInstallInDoor',
          label: (
            'First, try installing Codebox to front door handle so it is secured and can\'t be removed.'
          ),
        },
        {
          value: 'codeboxInstallElsewhere',
          label: (
            'If that handle doesn\'t support this, attach the Codebox to anything near ' +
            'the door such that the key on the string can still reach and unlock the door.'
          ),
        },
        {
          value: 'codeboxLeaveOnTheGround',
          label: (
            'If there is nothing to attach it to, leave the codebox ' +
            'free-standing on the ground near the door.'
          ),
        },
      ];
      break;

    case JOB_TYPE_CODEBOX_TAKEDOWN:
      jobChecklist = [
        {
          value: 'codeboxTakedownSpare9VBattery',
          label: 'Make sure to have a spare 9V battery in hand.',
        },
        {
          value: 'removeCodebox',
          label: 'Return the key from the Codebox to the combo lockbox.',
        },
        {
          value: 'codeboxTakedownCompletionPhotos',
          label: 'Take completion photo and upload photo',
        },
      ];
      break;

    case JOB_TYPE_SPECIAL_REQUEST:
      jobChecklist = [
        {
          value: 'specialRequestReturnKey',
          label: 'I confirm that I have read and followed the order instructions.',
        },
      ];
      break;

    case JOB_TYPE_FIX:
      jobChecklist = [
        {
          value: 'fixReturnKey',
          label: 'I confirm that I have read and followed the order instructions.',
        },
      ];
      break;

    case JOB_TYPE_PROPERTY_CHECK:
      jobChecklist = [
        {
          value: 'takePhotos',
          label: 'Please check the conditions of the home and attach any photos of issues that Sunroom needs to be made aware of.', // eslint-disable-line max-len
        },
        {
          value: 'testSelfTour',
          label: 'Test self-tour works via the app.',
        },
        {
          value: 'testMasterGuestCode',
          label: 'Test master and guest code works.',
        },
        {
          value: 'locksCovered',
          label: 'Inside locks are covered with yellow tape.',
        },
        {
          value: 'raspberryPiInstalled',
          label: 'Raspberry Pi installed?',
        },
        {
          value: 'cellularAntennaInstalled',
          label: 'Cellular antenna installed?',
        },
        {
          value: 'cellularAntennaColor',
          label: 'Color of the light on the cellular antenna',
        },
        {
          value: 'noBugs',
          label: 'Home is free of bugs',
        },
        {
          value: 'homeClean',
          label: 'Home is clean',
        },
        {
          value: 'lawnIsCut',
          label: 'Lawn is cut',
        },
        {
          value: 'windowsOk',
          label: 'All windows in good condition',
        },
        {
          value: 'urlWorks',
          label: 'Test URL goes to correct home',
        },
      ];
      break;

    case JOB_TYPE_MEDIA_CURBSHOT:
      jobChecklist = [
        {
          value: 'takeExteriorPhoto',
          label: 'Take at least 1 exterior photo of the front of the house',
        },
        {
          value: 'maximizeCurbshot',
          label: 'Ensure that this photo maximizes the curb appeal of the home',
        },
      ];
      break;
    case JOB_TYPE_REPLACE_SUNLOCK_BATTERY: {
      jobChecklist = [
        {
          value: 'replaceSunlockBatteryCheckSelfTourable',
          label: 'Is the sunlock self-tourable via the app after replacing the batteries? Add to notes.',
        },
        {
          value: 'replaceSunlockBatteryKeysInLockbox',
          label: 'Are the keys all in the lockbox? Add to notes.',
        },
        {
          value: 'replaceSunlockBatteryProgramLock',
          label: (
            'Program auto lock for one minute (Press the program button and then A ' +
            'button and then 3 one time and then 9 make sure the light is green)'
          ),
        },
        {
          value: 'replaceSunlockBatteryLockingMoreThanOnce',
          label: 'Is the auto-lock locking more than once with the door closed? Add to notes.',
        },
        {
          value: 'replaceSunlockBatteryTips',
          label: (
            'Please write any tips for opening the door in the notes section (do ' +
            'you need to push, pull, or lift the handle, etc). '
          ),
        },
      ];
      break;
    }

    case JOB_TYPE_CHECK_DOOR_LOCK: {
      jobChecklist = [
        {
          value: 'checkDoorLockDoorHandleLocked',
          label: 'Is the door handle locked? Write in the notes.',
        },
        {
          value: 'checkDoorLockDoorHandleIssue',
          label: 'If the door handle is not locked please write the issue in the notes section.',
        },
        {
          value: 'checkDoorLockTestSelfTourWorks',
          label: 'Test self-tour works.',
        },
        {
          value: 'checkDoorLockVerifyKeysInLockbox',
          label: 'Verify all keys are in the lockbox. Take a photo of it.',
        },
        {
          value: 'checkDoorLockOpeningTips',
          label: (
            'Please write any tips for opening the door in the notes section ' +
            '(do you need to push, pull, or lift the handle, etc).'
          ),
        },
      ];
      break;
    }

    case JOB_TYPE_SUNLOCK_TAKEDOWN_AND_SWAP:
      jobChecklist = [
        {
          value: 'uninstallSunlock',
          label: 'Uninstall the Sunlock',
        },
        {
          value: 'installKwikset',
          label: 'Install new Kwikset Smart Lock.',
        },
        {
          value: 'newMasterCode',
          label: 'Program new master code: 9009',
        },
        {
          value: 'newVendorCode',
          label: 'Program new vendor code: 2620',
        },
        {
          value: 'newTenantCode',
          label: 'Tenant Code: Provided in the order.',
        },
        {
          value: 'removeTapeFromDeadbolt',
          label: 'Remove any tape from the extra deadbolt.',
        },
        {
          value: 'removeTapeFromInnerLocks',
          label: 'Remove yellow tape from inner locks.',
        },
        {
          value: 'unplugRaz',
          label: 'Unplug the Raz pi and cellular data stick.',
        },
        {
          value: 'removePlacards',
          label: 'Remove the placards and URL placard from the door.',
        },
        {
          value: 'removeLockDoorStickers',
          label: 'Remove lock door stickers.',
        },
        {
          value: 'removeComboLockbox',
          label: 'Remove combo lockbox and all keys.',
        },
        {
          value: 'removeRentlyLock',
          label: 'Remove Rently lock and store until further instructed.',
        },
      ];
      break;

    default:
      break;
  }

  return jobChecklist;
}
